import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { CheckoutPageEvents } from '../../instrumentation/resort-custom-events';
import { UserActivityLogger, UserActivityLoggerOptions } from '../../instrumentation/user-activity-logger.service';
import { DisplayValue } from '../../models/browser.model';
import { ResortDetail } from '../../models/presentation.model';
import { ResortApplicationBase } from '../../services/resort-application.service';
import { Member, OvsComponent } from '../../shared/core/ovs.core';

@Component({
  selector: 'guest-form',
  templateUrl: './guest-form.component.html',
  styleUrls: ['./guest-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GuestFormComponent extends OvsComponent {
  @Input() guestForm: FormGroup;
  @Input() guestIndex: number;
  @Input() resort: ResortDetail;
  @Input() members: Member[] = [];
  @Input() application: ResortApplicationBase;
  @Input() months: DisplayValue<number>[];
  @Input() years: DisplayValue<number>[];
  @Input() removedMember: Member[] = [];
  @Input() usedMembers: number[] = [];

  @Output() removeGuest: EventEmitter<number> = new EventEmitter();
  @Output() telemarketingConsent: EventEmitter<void> = new EventEmitter();
  @Output() onSelectGuestMember: EventEmitter<void> = new EventEmitter();

  days: DisplayValue<number>[] = [];

  private hideSelectGuest: boolean = false;

  get FirstName(): AbstractControl {
    return this.guestForm.get('FirstName');
  }

  get LastName(): AbstractControl {
    return this.guestForm.get('LastName');
  }

  get DobMonth(): AbstractControl {
    return this.guestForm.get('DobMonth');
  }

  get DobDay(): AbstractControl {
    return this.guestForm.get('DobDay');
  }

  get DobYear(): AbstractControl {
    return this.guestForm.get('DobYear');
  }

  get EmailAddress(): AbstractControl {
    return this.guestForm.get('EmailAddress');
  }

  get PhoneNumber(): AbstractControl {
    return this.guestForm.get('PhoneNumber');
  }

  get isDuplicated(): AbstractControl {
    return this.guestForm.get('isDuplicated');
  }

  constructor() {
    super();
  }

  initialize(): void {
    if (this.members.length <= 2) {
      this.hideSelectGuest = true;
    }
  }

  onRemoveGuest(guestIndex: number): void {
    this.removeGuest.emit(guestIndex);
  }

    /**
   * Validate the status of the guest list
   * @param guestIndex number
   */
  isDisabled(guestIndex: number): boolean {
    return this.usedMembers.indexOf(guestIndex) !== -1? true : false ;
  }

  /**
   * Log Event each time FirstGuest Name/lastName has changed
   * @param index 
   */
  onFirstGuestNameBlur(index: number): void {
    if (index === 0) {
      UserActivityLogger.logEvent(
        CheckoutPageEvents.FirstGuestNameUpdated,
        {},
        UserActivityLoggerOptions.AppInsightsOnly
      );
    }
  }

  /**
   * Handle the guest selector control
   * @param guestForm 
   */
  onGuestMemberChanged(guest): void {
    
    const selectedGuest = this.guestForm.get('selectedGuest').value;
    if (selectedGuest) {
      this.FirstName.setValue(selectedGuest.FirstName, {emitEvent: false});
      this.LastName.setValue(selectedGuest.LastName, {emitEvent: false});
    }

    this.onSelectGuestMember.emit(selectedGuest);
  }

  /**
   * Set the days options for DobDay control
   */
  setDaysOptions(): void {
    const month = this.DobMonth.value;
    const year = this.DobYear.value;
    const daysInMonth: number = 32 - new Date(year ? year : 2016, month - 1, 32).getDate();
    let days: DisplayValue<number>[] = [];

    for (let index: number = 1; index <= daysInMonth; index++) {
      days.add(new DisplayValue(index, index.toString()));
    }

    this.days = days;
  }

  /**
   * Emit event to show telemarketingConsent details modal
   */
  showTelemarketingConsent(): void {
    this.telemarketingConsent.emit();
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/check-out/guest-form/guest-form.component.ts